import React, { Dispatch, FC, memo, SetStateAction } from "react";
import { useLocation } from "react-router-dom";
import { useFlags } from "launchdarkly-react-client-sdk";

import {
  SecondaryNavigationBarStyled,
  SecondaryNavBarItems,
  SecondaryNavItemStyled,
  SecondaryNavTitleStyled,
} from "./styles";

interface SecondaryLinkItemType {
  id: string;
  text: string;
  link: string;
}

const linksConfig: Array<SecondaryLinkItemType> = [
  {
    id: "missions",
    text: "Missions",
    link: "/missions",
  },
  {
    id: "live_missions",
    text: "Live Missions",
    link: "/live_missions",
  },
  {
    id: "queued_missions",
    text: "Queue Manager",
    link: "/queued_missions",
  },
];

export const SecondaryNavBarMissions: FC<{
  isSecondaryNavMissionsShown: boolean;
  setIsSecondaryNavMissionsShown: Dispatch<SetStateAction<boolean>>;
}> = memo(({ isSecondaryNavMissionsShown, setIsSecondaryNavMissionsShown }) => {
  const { pathname } = useLocation();
  const { featureFlagQueueManager, featureFlagLiveMissions } = useFlags();

  const filteredLinks = linksConfig.filter(({ id }) => {
    if (id === "live_missions") {
      return featureFlagLiveMissions;
    }
    if (id === "queued_missions") {
      return featureFlagQueueManager;
    }
    return true;
  });

  return (
    <SecondaryNavigationBarStyled
      isShown={isSecondaryNavMissionsShown}
      onMouseEnter={() => {
        setIsSecondaryNavMissionsShown(true);
      }}
      onMouseLeave={() => {
        setIsSecondaryNavMissionsShown(false);
      }}
    >
      <SecondaryNavBarItems>
        {filteredLinks.map(({ id, link, text }) => (
          <SecondaryNavItemStyled
            key={id}
            data-test-id={`nav-${id}`}
            to={link}
            $active={pathname === link}
            onClick={() => {
              setIsSecondaryNavMissionsShown(false);
            }}
          >
            <SecondaryNavTitleStyled>{text}</SecondaryNavTitleStyled>
          </SecondaryNavItemStyled>
        ))}
      </SecondaryNavBarItems>
    </SecondaryNavigationBarStyled>
  );
});
